import { ComboBox, DefaultButton, DialogFooter, Icon, IconButton, IStackTokens, Label, MessageBar, MessageBarType, Modal, PrimaryButton, Spinner, SpinnerSize, Stack, StackItem, Text, TextField, Toggle, TooltipHost } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { add, dismissMessage, get, reset, setStage1, update } from "./CurrenciesFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, InputField, NumberInputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../repository/Accountant/common_pb";
import { UpdateCurrencyRequest, AddCurrencyRequest, GetCurrencyRequest, AddCurrencyResponse, UpdateCurrencyResponse, CurrencyForm } from "../../../../repository/Accountant/currency_pb";


let req: AddCurrencyRequest;
let updateReq: UpdateCurrencyRequest;

let promise: any;

let org: number = -1;
let current: AuthenticateReply.AsObject;

export const CurrenciesForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();


    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any } = useAppSelector((state) => {

        return { isLoading: state.currenciesForm.isLoading, message: state.currenciesForm.message, stage1: state.currenciesForm.stage1 }
    })

    useEffect(() => {
        var l = searchParams.get('org');
        req = new AddCurrencyRequest();
        updateReq = new UpdateCurrencyRequest()
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
            }
        }

        if (props.type == FormType.EDIT) {
            if (props.fetchData) {
                let r = new GetCurrencyRequest()
                r.setId(props?.renderObject?.id);
                promise?.abort()
                promise = dispatch(get({ body: r, headers: getHeaders() }))
            } else {
                dispatch(setStage1(props?.renderObject))
            }
        }


        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])



    return (
        <>

            <Formik
                enableReinitialize={true}
                initialValues={{

                    name: (props.renderObject) ? props.renderObject?.name : '',
                    code: (props.renderObject) ? props.renderObject?.code : '',
                    symbol: (props.renderObject) ? props.renderObject?.symbol : '',
                    icon: (props.renderObject) ? props.renderObject?.icon : '',
                    decimalPlaces: (props.renderObject) ? props.renderObject?.decimalPlaces : 2,
                    form: (props.renderObject?.form) ? { key: props.renderObject?.form, text: "" } : { key: 1, text: t("fiatForm") },
                    isAvailable: (props.renderObject) ? props.renderObject.isAvailable : true,
                    extraFields: (state.stage1?.extraFields) ? state.stage1?.extraFields as DynamicField[] : [] as DynamicField[],

                }}

                validationSchema={props.type == FormType.ADD ? Yup.object({

                    name: inputs.currencyName,
                    code: inputs.currencyCode,
                    symbol: inputs.currencySymbol,
                    icon: inputs.currencyIcon,
                    decimalPlaces: inputs.currencyDecimalPlaces,
                    extraFields: inputs.extraFields,

                }) : Yup.object({

                    name: inputs.currencyName,
                    code: inputs.currencyCode,
                    symbol: inputs.currencySymbol,
                    icon: inputs.currencyIcon,
                    extraFields: inputs.extraFields,

                })}

                onSubmit={(values, actions) => {
                    if (props.type == FormType.ADD) {
                        req.setName(values.name.trim());
                        req.setIsavailable(values.isAvailable);
                        req.setCode(values.code.trim())
                        req.setSymbol(values.symbol.trim())
                        req.setDecimalplaces(Number(values.decimalPlaces))
                        req.setIconsource(values.icon)
                        let cf = new CurrencyForm();
                        cf.setId(values.form.key);
                        req.setForm(cf)
                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        req.setExtrafieldsList(extraField)
                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: AddCurrencyResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res.success?.id,
                                            name: values.name.trim(),
                                            isAvailable: values.isAvailable,
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,
                                            code: values.code,
                                            icon: values.icon,
                                            form: values.form.key,
                                            symbol: values.symbol,
                                            decimalPlaces: values.decimalPlaces

                                        });
                                    }
                                }
                                actions.setSubmitting(false)

                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {
                        updateReq.setName(values.name.trim());
                        updateReq.setIsavailable(values.isAvailable)
                        updateReq.setCode(values.code.trim())
                        updateReq.setSymbol(values.symbol.trim())
                        updateReq.setIconsource(values.icon)
                        let cf = new CurrencyForm();
                        cf.setId(values.form.key);
                        updateReq.setForm(cf);
                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        updateReq.setExtrafieldsList(extraField)
                        updateReq.setId(props.renderObject?.id)
                        promise = dispatch(update({ body: updateReq, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: UpdateCurrencyResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            ...props.renderObject,
                                            name: values.name.trim(),
                                            isAvailable: values.isAvailable,
                                            extraFields: values.extraFields,
                                            code: values.code,
                                            icon: values.icon,
                                            form: values.form.key,
                                            symbol: values.symbol,
                                            decimalPlaces: values.decimalPlaces

                                        });
                                    }
                                }
                                actions.setSubmitting(false)

                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    }
                }}

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }
                                    <Field name="name" label={t("currencyName")} placeholder={t("currencyNameHint")} component={InputField} disabled={state.isLoading} autoFocus required maxLength={50} />
                            <Stack horizontal  tokens={{ childrenGap: props.childrenGap }}>
                     
                                <Stack.Item grow>
                                    <Field name="code" label={t("currencyCode")} placeholder={"USD"} component={InputField} disabled={state.isLoading} maxLength={4} required />
                                </Stack.Item>
                                <Stack.Item grow>
                                    <Field name="symbol" label={t("currencySymbol")} placeholder={"$"} component={InputField} disabled={state.isLoading} maxLength={4} required />
                                </Stack.Item>
                            </Stack>



                            {props.type == FormType.ADD ? <Stack>
                                <Label required disabled={state.isLoading}>{t("currencyDecimalPlaces")} </Label>
                                <Field name="decimalPlaces" placeholder={2}
                                    component={NumberInputField} disabled={state.isLoading} max={10} min={0} step={1} required />
                            </Stack> : undefined}

                            <Field name="icon" label={t("currencyIcon")} placeholder={"https://icons.com/usd.png"} component={InputField} disabled={state.isLoading} maxLength={2048} />
                            <ComboBox
                                label={t("currencyForm")}
                                allowFreeform={true}
                                autoComplete={'on'}
                                disabled={state.isLoading}
                                options={[{ key: 1, text: t("fiatForm") }, { key: 4, text: t("digitalForm") }, { key: 2, text: t("cryptoForm") },
                                { key: 3, text: t("commodityForm") }, { key: 5, text: t("representativeForm") }]}
                                selectedKey={formkikProps.values.form.key}
                                onChange={(e, o) => {
                                    formkikProps.setFieldValue("form", { key: o?.key, text: o?.text })
                                }}
                            // Force re-creating the component when the toggles change (for demo purposes)
                            />
                            <Toggle

                                onText={t("available")} offText={t("unavailable")}
                                label={t("availability")}
                                disabled={state.isLoading}

                                checked={formkikProps.values.isAvailable}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    formkikProps.setFieldValue('isAvailable', checked);
                                }
                                }
                            />
                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("extraFields") + ' '}
                                    <TooltipHost content={t("extraInformationDescription")}>
                                        <Icon iconName="Info" aria-label={t("extraFields")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="extraFields"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.extraFields && formkikProps.values.extraFields.length > 0) {
                                        r = formkikProps.values.extraFields.map((o, index) => {
                                            if (o.type == 1) {
                                                return (<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }} key={index}>
                                                    {o.label != undefined ? <Stack.Item grow> <DynamicInputField name={`extraFields[${index}].label`} placeholder={t("extraFieldLabel")} disabled={state.isLoading}
                                                        maxLength={50} autoFocus={(o as any)?.autoFocus} /> </Stack.Item> : null}
                                                    <Stack.Item grow>  <DynamicInputField name={`extraFields[${index}].value`} placeholder={t("extraFieldValue")} disabled={state.isLoading}
                                                        maxLength={50}
                                                    /></Stack.Item>

                                                    <IconButton disabled={state.isLoading}
                                                        iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                </Stack>)
                                            }
                                        }
                                        )
                                    }
                                    if (formkikProps.values.extraFields.length <= 4) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.extraFields.length + 1) + "", label: "", type: 1, value: "", autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("add") : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>

                    </Form>
                )}
            </Formik>
        </>
    );

}

